import cn from 'classnames'
import React from 'react'
import { Helmet } from 'react-helmet'
import { useSelector } from 'react-redux'
import StreamAgentChat from 'src/agent/components/StreamAgentChat/StreamAgentChat'
import LayoutPage from 'src/component-layout/LayoutPage/LayoutPage'
import NotFoundBackgroundPage from 'src/components/NotFoundBackgroundPage/NotFoundBackgroundPage'
import { selectIsBetaOrgAgent } from 'src/redux/selectors/data/organizations.selectors'
import { selectAppName } from 'src/redux/selectors/session.selectors'

import style from './StreamingAgentPage.style'

const StreamingAgentPage: React.FC = () => {
  const appName = useSelector(selectAppName)
  const showExtendAI = useSelector(selectIsBetaOrgAgent)

  if (!showExtendAI) {
    return <NotFoundBackgroundPage />
  }

  return (
    <>
      <Helmet>
        <title>{`AI Agent | ${appName}`}</title>
        <meta name="description" content={`AI Agent page of ${appName}`} />
      </Helmet>
      <LayoutPage
        css={style}
        background={'white'}
        className={cn('StreamingAgentPage')}
        padding="none"
        fixedHeight
      >
        <StreamAgentChat />
      </LayoutPage>
    </>
  )
}

export default StreamingAgentPage
